import React from "react";
import { AnimateIn, StaggerIn } from "./AnimateIn";
import "./About.css";

const useCaseIcons = [
  // Medical Affairs
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>,
  // Clinical Strategy
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>,
  // Evidence Review
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
];

export const About = ({ data }) => {
  if (!data) return null;

  return (
    <section id="usecases" className="usecases-section">
      <div className="section-container">
        <AnimateIn variant="fadeUp">
          <div className="usecases-header">
            <p className="eyebrow">{data.eyebrow}</p>
            <h2 className="section-title">{data.title}</h2>
          </div>
        </AnimateIn>
        <StaggerIn variant="fadeUp" stagger={0.12} className="usecases-grid">
          {data.items.map((item, i) => (
            <div key={i} className="usecase-card">
              <div className="usecase-icon">{useCaseIcons[i]}</div>
              <h3 className="usecase-name">{item.title}</h3>
              <p className="usecase-desc">{item.description}</p>
            </div>
          ))}
        </StaggerIn>
      </div>
    </section>
  );
};
